define('webshopLandingpagesDetailBodyLandingpageBodyIndexView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'checkboxView'
], function (
  App,
  Module,
  Backbone,
  _,
  CheckboxView
) {
  'use strict';

  Module.exports = CheckboxView.extend({
    className: 'index-view ' + CheckboxView.prototype.className,

    attributes: function () {
      return _.extend({}, CheckboxView.prototype.attributes.apply(this, arguments), {
        'title': this.model.get('lang') || null
      });
    },

    initialize: function () {
      CheckboxView.prototype.initialize.apply(this, arguments);
      this.value = this.model.get('value');
      this.text = this.model.get('lang');
    },

    onChange: function (value) {
      var defer = $.Deferred();
      this.options.landingpage.setIndex(this.model.get('lang'), value).done(_.bind(function () {
        this.options.landingpage.fetch().done(_.bind(function () {
          defer.resolve();
        }, this));
      }, this)).fail(_.bind(function () {
        this.options.landingpage.fetch().done(_.bind(function () {
          defer.reject();
        }, this));
      }, this));
      return defer.promise();
    }
  });
});
